<div class="modal_dialog assign-brand-modal">
  <div class="modal_header">
    <h2>{{ "AssignVendor" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="form-container">
      <div class="form_group">
        <mat-label class="required"> {{ 'SelectType' | translate }} </mat-label>
        <mat-form-field appearance="fill">
          <mat-select
            [(ngModel)]="isMegaStoreVendor"
            placeholder="{{ 'SelectType' | translate }}"
            class="form_control">
            <mat-option [value]="true">{{ 'Mega Store Vendor' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'Other Vendor' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form_group" *ngIf="!isMegaStoreVendor">
        <megastore-admin-multi-column-select
          [options]="vendors"
          [selectionConfig]="{ value: '_id', label: 'name' }"
          [selectionMode]="'single'"
          [columns]="3"
          [maxHeight]="'400px'"
          [placeholder]="'SelectVendors' | translate"
          [label]="'SelectVendors' | translate"
          [ngModel]="selectedVendors"
          [defaultOpenState]="true"
          (ngModelChange)="onVendorSelectionChange($event)"
        ></megastore-admin-multi-column-select>
      </div>
      <div class="form_group" *ngIf="selectedVendors !== ''">
        <mat-label class="required"> {{ 'Outlet' | translate }} </mat-label>
        <mat-form-field appearance="fill">
          <mat-select
            [(ngModel)]="selectedOutlet"
            placeholder="{{ 'SelectOutlets' | translate }}"
            class="form_control">
            <mat-option
              *ngFor="let outlet of outlets"
              [value]="outlet._id">
              {{ outlet.outletName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="action-buttons">
        <button type="button" class="btnn btn_secondary" (click)="close()">
          {{ "Cancel" | translate }}
        </button>
        <button type="button" class="btnn btn_primary" (click)="save()">
          {{ "Save" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

